/* ============================================================
   Atelier cart drawer - functional controller
   ------------------------------------------------------------
   Server-rendered markup (snippets/atelier-cart.liquid), re-rendered live via
   the Section Rendering API (sections/atelier-cart.liquid). Handles:
   open/close + scroll-lock, optimistic quantity/remove (instant UI, batched
   server sync), note, the collapsible tools, the live shipping estimate, an
   in-flight progress bar, and a 429-tolerant fetch wrapper.

   window.atelierCartOn gates routing; window.openAtelierCart() is the entry.
   ============================================================ */
(function () {
  var drawer, scrim;
  var pending = {};      // { lineKey: targetQty } awaiting a batched sync
  var flushing = false;  // a /cart/update.js is in flight
  var inflight = 0;      // add / refresh / shipping requests in flight
  var flushTimer = null;

  /* ---------- small helpers ---------- */
  function lockScroll() {
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() { document.body.style.overflow = ''; document.body.style.paddingRight = ''; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Retry on 429 (dev proxy + multiple cart apps can rate-limit a burst). */
  function cartFetch(url, opts, tries) {
    tries = (tries == null) ? 3 : tries;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && tries > 0) {
        return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return cartFetch(url, opts, tries - 1); });
      }
      return r;
    });
  }

  /* Shopify money formatting (optimistic prices, client-side) */
  function formatMoney(cents) {
    var fmt = (window.atelierMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    function fmtNum(c, precision, thousands, decimal) {
      if (isNaN(c)) c = 0;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      precision = precision == null ? 2 : precision;
      var n = (c / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var pat = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(pat);
    if (!m) return fmt;
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': value = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmtNum(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = fmtNum(cents, 2, "'", '.'); break;
      default: value = fmtNum(cents, 2);
    }
    return fmt.replace(pat, value);
  }

  function refreshBar() {
    if (drawer) drawer.classList.toggle('loading', flushing || inflight > 0 || Object.keys(pending).length > 0);
  }

  /* ---------- open / close ---------- */
  function bind() {
    drawer = document.getElementById('AtelierCart');
    scrim = document.getElementById('AtelierCartScrim');
    if (!drawer || !scrim) return false;
    if (drawer.dataset.bound) return true;
    drawer.dataset.bound = '1';
    scrim.addEventListener('click', close);
    drawer.addEventListener('click', onClick);
    drawer.addEventListener('submit', onSubmit);
    drawer.addEventListener('input', onInput);
    drawer.addEventListener('focusin', function (e) { if (e.target.id === 'AtelierShipQ') loadLocs(); });
    drawer.addEventListener('focusout', function (e) { if (e.target.id === 'AtelierShipQ') setTimeout(function () { var l = document.getElementById('AtelierShipList'); if (l) l.classList.remove('on'); }, 150); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) close(); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.id === 'AtelierDiscInput') { e.preventDefault(); applyDiscount(); } });
    updateGoalMeter();
    return true;
  }
  function show() {
    if (!bind()) return;
    scrim.classList.add('on');
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
  }
  function open() { if (!bind()) return; show(); refresh().then(function () { cleanupOrphans(); }); }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('on');
    scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  /* ---------- render ---------- */
  function applySection(html, opts) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('AtelierCart');
    if (!fresh || !drawer) return;
    var itemsEl = drawer.querySelector('[data-ct-items]');
    if (opts && opts.noAnim && itemsEl) itemsEl.classList.add('no-anim');
    ['[data-ct-items]', '[data-ct-summary]', '[data-ct-disc]'].forEach(function (sel) {
      var f = fresh.querySelector(sel), c = drawer.querySelector(sel);
      if (f && c && f.innerHTML !== c.innerHTML) c.innerHTML = f.innerHTML;
    });
    ['[data-ct-count]', '[data-ct-total]', '[data-ct-disc-lbl]'].forEach(function (sel) {
      var f = fresh.querySelector(sel), c = drawer.querySelector(sel);
      if (f && c && f.textContent !== c.textContent) c.textContent = f.textContent;
    });
    drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    if (opts && opts.noAnim && itemsEl) requestAnimationFrame(function () { itemsEl.classList.remove('no-anim'); });
    updateGoalMeter();
  }

  function refresh() {
    inflight++; refreshBar();
    return cartFetch(rootUrl() + '?section_id=atelier-cart')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) { if (html) applySection(html); })
      .catch(function (e) { console.error('[atelier-cart] refresh', e); })
      .finally(function () { inflight--; refreshBar(); });
  }

  /* ---------- optimistic quantity / remove ---------- */
  function recompute() {
    var sub = 0, save = 0, count = 0;
    drawer.querySelectorAll('.ct-item').forEach(function (it) {
      var q = parseInt(it.getAttribute('data-qty'), 10) || 0;
      var u = +it.getAttribute('data-unit-price') || 0;
      var c = +it.getAttribute('data-unit-compare') || 0;
      sub += u * q; count += q;
      if (c > u) save += (c - u) * q;
    });
    /* order-level portion of applied discounts (code row + automatic-sale row,
       both server-rendered); line-level allocations are already inside data-unit-price */
    var disc = 0;
    drawer.querySelectorAll('[data-ct-disc-row],[data-ct-auto-row]').forEach(function (r) { disc += +r.getAttribute('data-disc') || 0; });
    disc = Math.min(disc, sub);
    var subEl = drawer.querySelector('[data-ct-summary] .ct-sub .val'); if (subEl) subEl.textContent = formatMoney(sub);
    var grand = drawer.querySelector('[data-ct-summary] .ct-tot .val'); if (grand) grand.textContent = formatMoney(sub - disc);
    /* grand savings line = markdown savings + discounts (approximation until
       the server re-render lands with exact allocations) */
    var saveTotal = save + disc;
    var sr = drawer.querySelector('[data-ct-summary] .ct-save-row');
    if (sr) { if (saveTotal > 0) { sr.classList.add('on'); var b = sr.querySelector('b'); if (b) b.textContent = formatMoney(saveTotal); } else sr.classList.remove('on'); }
    var co = drawer.querySelector('[data-ct-total]'); if (co) co.textContent = 'Checkout · ' + formatMoney(sub - disc);
    var cnt = drawer.querySelector('[data-ct-count]'); if (cnt) cnt.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    syncBadge(count);
    drawer.classList.toggle('is-empty', count === 0);
    updateGoalMeter();
  }
  function updateLine(it) {
    var q = parseInt(it.querySelector('.ct-qty .n').textContent, 10) || 0;
    var u = +it.getAttribute('data-unit-price') || 0;
    var c = +it.getAttribute('data-unit-compare') || 0;
    var now = it.querySelector('.ct-pr .now'); if (now) now.textContent = formatMoney(u * q);
    var was = it.querySelector('.ct-pr .was'); if (was && c > u) was.textContent = formatMoney(c * q);
  }
  function queue(key, qty) { pending[key] = qty; scheduleFlush(); }
  function scheduleFlush() { refreshBar(); clearTimeout(flushTimer); flushTimer = setTimeout(flush, 450); }
  function flush() {
    if (flushing) { scheduleFlush(); return; }
    var keys = Object.keys(pending);
    if (!keys.length) { refreshBar(); return; }
    flushing = true;
    var updates = pending; pending = {};
    var hadRemoval = false; for (var rk in updates) { if (updates[rk] === 0) hadRemoval = true; }
    refreshBar();
    cartFetch(rootUrl() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'atelier-cart', sections_url: location.pathname })
    })
      .then(function (r) { if (!r.ok) { console.error('[atelier-cart] update http', r.status); return null; } return r.json(); })
      .then(function (data) {
        if (!data) { refresh(); return; }   // sync failed → revert UI to the server's real cart
        if (data.sections && data.sections['atelier-cart']) applySection(data.sections['atelier-cart'], { noAnim: true });
        syncBadge(data.item_count);
        resetShip();
        if (hadRemoval) cleanupOrphans();
      })
      .catch(function (e) { console.error('[atelier-cart] update', e); refresh(); })
      .finally(function () {
        flushing = false; refreshBar();
        if (Object.keys(pending).length) scheduleFlush();
      });
  }

  /* ---------- badge ---------- */
  function syncBadge(count) {
    if (count == null) return;
    document.querySelectorAll('.fkcart-shortcode-count, .fkcart-item-count').forEach(function (el) {
      el.textContent = count; el.setAttribute('data-item-count', count);
    });
  }
  function syncBadgeFromDrawer() {
    var el = drawer && drawer.querySelector('[data-ct-count]');
    if (el) { var m = el.textContent.match(/\d+/); if (m) syncBadge(m[0]); }
  }

  /* Vanity Builder orphan cleanup — remove child add-ons whose parent vanity
     was removed (mirrors the old CornerCart safeguard). A parent is any line
     with a 'Cabinet Finish' property; a child ('Added with') is orphaned if its
     value matches no parent's product_title or handle. */
  var cleanupRunning = false;
  function cleanupOrphans() {
    if (cleanupRunning) return Promise.resolve();
    cleanupRunning = true;
    return cartFetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var parents = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p['Cabinet Finish']) { if (it.product_title) parents[it.product_title] = 1; if (it.handle) parents[it.handle] = 1; }
        });
        var updates = {}, any = false;
        (cart.items || []).forEach(function (it) {
          var aw = (it.properties || {})['Added with'];
          if (aw && !parents[aw]) { updates[it.key] = 0; any = true; }
        });
        if (!any) return;
        console.log('[atelier-cart] removing orphaned Vanity Builder children');
        return cartFetch(rootUrl() + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: 'atelier-cart', sections_url: location.pathname })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (data && data.sections && data.sections['atelier-cart']) applySection(data.sections['atelier-cart'], { noAnim: true });
            if (data) syncBadge(data.item_count);
          });
      })
      .catch(function (e) { console.warn('[atelier-cart] orphan cleanup', e); })
      .finally(function () { cleanupRunning = false; });
  }

  /* ---------- CornerCart goal meter (tiered discount bar) ----------
     Mirrors the CornerCart "goal_meter_in_cart" campaign in Atelier styling.
     READ-ONLY consumer: campaign state (tiers, copy templates, schedule,
     active/off) comes from window.corner.campaigns, which the CornerCart app
     embed injects into every page. Staff enable/disable the feature in the
     CornerCart admin and this bar follows automatically - there is no theme-side
     toggle. Discount codes are applied by CornerCart's own engine (it monitors
     /cart/add|update|change independently of its UI); we never create, apply or
     edit codes here. */
  function goalCampaign() {
    try {
      var arr = window.corner && window.corner.campaigns;
      if (!arr || !arr.length) return null;
      var now = Date.now();
      for (var i = 0; i < arr.length; i++) {
        var c = arr[i];
        if (!c || c.type !== 'goal_meter_in_cart' || c.surface !== 'cart_widget') continue;
        if (c.status !== 'active') continue;
        if (c.audience && c.audience.everyone !== true) continue; // targeted audiences: let CornerCart handle
        var s = c.schedule || {};
        if (s.startsAt && now < Date.parse(s.startsAt)) continue;
        if (s.endsAt && now > Date.parse(s.endsAt)) continue;
        var d = c.details || {};
        if (d.goalType !== 'totalOrderValue') continue;       // order-value goals only (current store usage)
        if (!d.milestones || !d.milestones.length) continue;
        return d;
      }
    } catch (e) { console.warn('[atelier-cart] goal campaign parse', e); }
    return null;
  }
  function fillTpl(tpl, map) {
    return String(tpl == null ? '' : tpl).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : '';
    });
  }
  /* "$1,234.00" -> "$1,234" when whole dollars (matches the CornerCart bar's copy) */
  function moneyTrim(cents) {
    return formatMoney(Math.max(0, Math.round(cents))).replace(/([.,]00)(?!\d)/, '');
  }
  function tierDiscountLabel(mi) {
    var rs = mi && mi.rewards && mi.rewards.rewardStack && mi.rewards.rewardStack[0];
    if (!rs) return '';
    return rs.unit === 'percent' ? rs.value + '%' : moneyTrim(rs.value * 100);
  }
  var GOAL_CHECK = '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
  /* same tag glyph as the drawer's "Discount code" tool, so locked tiers read as discounts */
  var GOAL_TAG = '<svg viewBox="0 0 24 24"><path d="M20.6 13.4 11 3.8a2 2 0 0 0-1.4-.6H4.6A1.6 1.6 0 0 0 3 4.8v5a2 2 0 0 0 .6 1.4l9.6 9.6a2 2 0 0 0 2.8 0l4.6-4.6a2 2 0 0 0 0-2.8Z"/><path d="M7.5 7.5h.01"/></svg>';
  function updateGoalMeter() {
    var mount = document.getElementById('AtelierCartGoal');
    if (!mount) return;
    var d = goalCampaign();
    var sub = 0, count = 0;
    if (drawer) drawer.querySelectorAll('.ct-item').forEach(function (it) {
      var q = parseInt(it.getAttribute('data-qty'), 10) || 0;
      sub += (+it.getAttribute('data-unit-price') || 0) * q;
      count += q;
    });
    if (!d || count === 0) { mount.hidden = true; mount.innerHTML = ''; return; }

    var tiers = d.milestones.slice().sort(function (a, b) { return a.goal - b.goal; });
    var cur = sub / 100;                                   // goals are whole dollars (goalUnit AUD)
    var achieved = 0;
    tiers.forEach(function (t) { if (cur >= t.goal) achieved++; });
    var next = achieved < tiers.length ? tiers[achieved] : null;

    /* headline: next tier's preGoalText, or the last tier's postGoalText when all are unlocked */
    var msgTier = next || tiers[tiers.length - 1];
    var msg = fillTpl((msgTier.content || {})[next ? 'preGoalText' : 'postGoalText'], {
      goal: '<b>' + moneyTrim((msgTier.goal - cur) * 100) + '</b>',
      discount: tierDiscountLabel(msgTier),
      current_status: moneyTrim(sub)
    });

    /* equal segments per tier (parity with the CornerCart bar's layout);
       fill = completed segments + progress within the current segment */
    var seg = 1 / tiers.length, fill;
    if (!next) fill = 1;
    else {
      var prev = achieved > 0 ? tiers[achieved - 1].goal : 0;
      var frac = (cur - prev) / (next.goal - prev || 1);
      fill = seg * achieved + seg * Math.max(0, Math.min(1, frac));
    }

    var stops = '', labels = '';
    tiers.forEach(function (t, i) {
      var x = ((i + 1) / tiers.length * 100).toFixed(3) + '%';
      var on = i < achieved ? ' on' : '';
      stops += '<span class="ct-goal-stop' + on + '" style="left:' + x + '">' + (on ? GOAL_CHECK : GOAL_TAG) + '</span>';
      labels += '<span class="ct-goal-lb' + on + '" style="left:' + x + '">' +
        fillTpl((t.content || {}).milestoneLabel, { discount: tierDiscountLabel(t) }) + '</span>';
    });

    mount.innerHTML =
      '<div class="ct-goal-msg" aria-live="polite">' + msg + '</div>' +
      '<div class="ct-goal-bar" role="img" aria-label="Discount progress: ' + achieved + ' of ' + tiers.length + ' tiers unlocked">' +
        '<span class="ct-goal-track"></span>' +
        '<span class="ct-goal-fill" style="width:' + (fill * 100).toFixed(2) + '%"></span>' +
        stops +
      '</div>' +
      '<div class="ct-goal-lbs">' + labels + '</div>';
    mount.hidden = false;
  }

  /* ---------- note ---------- */
  function saveNote(v) {
    fetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) })
      .catch(function (e) { console.error('[atelier-cart] note', e); });
  }

  /* ---------- discount code (applied IN cart, not at checkout) ----------
     POST /cart/update.js {discount: CODE} attaches the code to the cart
     server-side; '' removes all codes (single-code UX by design, so that is
     exactly "remove the code"). The re-rendered section is the truth for
     totals and applied state; the JSON response's discount_codes[].applicable
     (when present) additionally catches codes Liquid cannot see in-cart
     (e.g. shipping-only codes, which have no cart-level money effect). */
  function setDiscMsg(text, err) {
    var m = document.getElementById('AtelierDiscMsg');
    if (m) { m.className = 'ct-disc-msg' + (err ? ' err' : ''); m.textContent = text || ''; }
  }
  function closeTools() {
    drawer.querySelectorAll('.ct-tool').forEach(function (x) { x.classList.remove('on'); });
    drawer.querySelectorAll('.ct-tool-panel').forEach(function (p) { p.classList.remove('on'); });
    var w = document.getElementById('AtelierToolWrap'); if (w) w.classList.remove('open');
  }
  function postDiscount(value) {
    return cartFetch(rootUrl() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: value, sections: 'atelier-cart', sections_url: location.pathname })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, data: j }; });
    });
  }
  function codeApplicable(data, code) {
    var codes = data && data.discount_codes;
    if (!codes || typeof codes.some !== 'function') return null;   // field absent -> decide from the section render
    return codes.some(function (c) { return String(c.code || '').toLowerCase() === code.toLowerCase() && c.applicable !== false; });
  }
  function applyDiscount() {
    var input = document.getElementById('AtelierDiscInput');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var btn = document.getElementById('AtelierDiscBtn'); if (btn) btn.disabled = true;
    inflight++; refreshBar(); setDiscMsg('');
    postDiscount(code)
      .then(function (res) {
        var data = res.data;
        if (!res.ok || !data) {
          setDiscMsg((data && (data.description || data.message)) || 'Could not apply that code. Please try again.', true);
          return;
        }
        if (data.sections && data.sections['atelier-cart']) applySection(data.sections['atelier-cart'], { noAnim: true });
        var pill = drawer.querySelector('[data-ct-disc-row]');
        var known = codeApplicable(data, code);
        var ok = (known === null) ? !!pill : known;
        if (ok && pill) {
          /* one-time voucher entrance + sheen (CSS .just-on); class lifted
             after the animation so overflow never clips the tap window at rest */
          pill.classList.add('just-on');
          setTimeout(function () { pill.classList.remove('just-on'); }, 1300);
          closeTools();                       // label now carries the code; the summary row shows it applied
        } else if (ok) {
          /* valid per the API but invisible to cart Liquid (shipping-only):
             keep it on the cart and say where it lands */
          var lbl = document.getElementById('AtelierDiscLbl'); if (lbl) lbl.textContent = code.toUpperCase();
          setDiscMsg('Code ' + code.toUpperCase() + ' will be applied at checkout.');
        } else {
          /* an inapplicable code may still be stored on the cart - take it
             back off FIRST; the message is written after the cleanup's
             re-render lands, or that swap wipes it (and the typed code) */
          postDiscount('').then(function (res2) {
            var d2 = res2.data;
            if (d2 && d2.sections && d2.sections['atelier-cart']) applySection(d2.sections['atelier-cart'], { noAnim: true });
          }).catch(function () { /* section already shows no discount */ })
            .then(function () {
              var inp = document.getElementById('AtelierDiscInput');
              if (inp && !inp.value) inp.value = code;
              /* Shopify stores unknown codes as "not applicable" rather than
                 saying they don't exist, so cover both honestly */
              setDiscMsg('That code isn\'t valid or can\'t be used on this cart. Check the spelling and try again.', true);
            });
        }
      })
      .catch(function (e2) { setDiscMsg('Could not apply that code. Please try again.', true); console.error('[atelier-cart] discount', e2); })
      .finally(function () { var b = document.getElementById('AtelierDiscBtn'); if (b) b.disabled = false; inflight--; refreshBar(); });
  }
  function removeDiscount(refocus) {
    inflight++; refreshBar(); setDiscMsg('');
    postDiscount('')
      .then(function (res) {
        if (!res.ok || !res.data) { refresh(); return; }
        var data = res.data;
        if (data.sections && data.sections['atelier-cart']) applySection(data.sections['atelier-cart'], { noAnim: true });
        if (refocus) { var inp = document.getElementById('AtelierDiscInput'); if (inp) inp.focus(); }
      })
      .catch(function (e2) { console.error('[atelier-cart] discount remove', e2); refresh(); })
      .finally(function () { inflight--; refreshBar(); });
  }

  /* ---------- shipping estimate (suburb/postcode search → live carrier rate) ---------- */
  /* Lazy-loaded AU localities ("Suburb|POSTCODE|STATE") for the search field. */
  var LOCS = null, locsLoading = null;
  function loadLocs() {
    if (LOCS) return Promise.resolve(LOCS);
    if (locsLoading) return locsLoading;
    // Loaded via <script> (not fetch) so it works cross-origin from the CDN
    // on both the dev preview and live — no CORS / mixed-content issues.
    locsLoading = new Promise(function (resolve) {
      if (window.atelierLocs) { LOCS = window.atelierLocs; resolve(LOCS); return; }
      var s = document.createElement('script');
      s.src = window.atelierLocalitiesUrl;
      s.onload = function () { LOCS = window.atelierLocs || []; resolve(LOCS); };
      s.onerror = function () { LOCS = []; console.warn('[atelier-cart] localities failed to load'); resolve(LOCS); };
      document.head.appendChild(s);
    });
    return locsLoading;
  }
  function searchLocs(q) {
    q = (q || '').trim().toLowerCase();
    if (q.length < 2 || !LOCS) return [];
    var byPc = /^\d+$/.test(q), res = [];
    for (var i = 0; i < LOCS.length && res.length < 8; i++) {
      var p = LOCS[i].split('|');                 // [suburb, postcode, state]
      var hay = byPc ? p[1] : p[0].toLowerCase();
      if (hay.indexOf(q) === 0) res.push(p);
    }
    return res;
  }
  function renderShipList(results) {
    var list = document.getElementById('AtelierShipList');
    if (!list) return;
    if (!results.length) { list.classList.remove('on'); list.innerHTML = ''; return; }
    list.innerHTML = results.map(function (p) {
      return '<li class="ct-ship-opt" role="option" data-s="' + esc(p[0]) + '" data-pc="' + p[1] + '" data-st="' + p[2] + '"><b>' + esc(p[0]) + '</b><span>' + p[2] + ' ' + p[1] + '</span></li>';
    }).join('');
    list.classList.add('on');
  }
  function fmtRate(p) { var n = parseFloat(p) || 0; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  var TRUCK = '<svg class="ct-ship-tk" viewBox="0 0 24 24"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7.5" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  var EDIT = '<svg class="ct-ship-edit" viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  function resetShip() {
    var ship = document.getElementById('AtelierShip'); if (ship) ship.classList.remove('done');
    var lbl = document.getElementById('AtelierShipLbl'); if (lbl) lbl.textContent = 'Estimate shipping';
  }
  /* Shared "deliver to" locality (PDP freight estimator + cart page use the
     same key) - enter a suburb once anywhere, remembered everywhere. */
  function saveLoc(s, pc, st) {
    try { localStorage.setItem('atelierDeliverTo', JSON.stringify({ s: s, pc: pc, st: st })); } catch (e) { /* ignore */ }
  }
  function loadLoc() {
    try {
      var v = JSON.parse(localStorage.getItem('atelierDeliverTo') || 'null');
      if (v && v.s && v.pc && v.st) return v;
    } catch (e) { /* ignore */ }
    return null;
  }
  /* Poll the async rates endpoint until the carrier calc resolves
     (shipping_rates is null while computing, an array when done). */
  function pollRates(attempt) {
    return cartFetch(rootUrl() + 'cart/async_shipping_rates.json', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var rates = data ? data.shipping_rates : null;
        if (rates === null || rates === undefined) {
          if (attempt >= 8) return [];   // ~5s ceiling, then give up
          return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return pollRates(attempt + 1); });
        }
        return rates;
      });
  }
  function pickLocality(suburb, pc, st) {
    saveLoc(suburb, pc, st);
    var list = document.getElementById('AtelierShipList'); if (list) { list.classList.remove('on'); list.innerHTML = ''; }
    var q = document.getElementById('AtelierShipQ'); if (q) q.value = suburb + ', ' + st + ' ' + pc;
    var msg = document.getElementById('AtelierShipMsg'); msg.textContent = '';
    var ship = document.getElementById('AtelierShip'); if (ship) ship.classList.add('loading');
    inflight++; refreshBar();
    var addr = 'shipping_address%5Bzip%5D=' + encodeURIComponent(pc) +
      '&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=' + encodeURIComponent(st) +
      '&shipping_address%5Bcity%5D=' + encodeURIComponent(suburb);
    // Async flow: prepare kicks off the (possibly slow) carrier calc; then poll.
    cartFetch(rootUrl() + 'cart/prepare_shipping_rates.json?' + addr, { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { return pollRates(0); })
      .then(function (rates) {
        rates = rates || [];
        if (!rates.length) { msg.textContent = 'No delivery rates available to ' + suburb + ' ' + pc + '.'; return; }
        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var r = rates[0], free = parseFloat(r.price) === 0, price = free ? 'FREE' : fmtRate(r.price);
        document.getElementById('AtelierShipRes').innerHTML =
          TRUCK + '<span class="ct-ship-rtxt">' + esc(r.name) + ' to <b>' + esc(suburb) + ' ' + pc + '</b></span>' +
          '<span class="ct-ship-rprice' + (free ? ' free' : '') + '">' + price + '</span>' + EDIT;
        document.getElementById('AtelierShip').classList.add('done');
        document.getElementById('AtelierShipLbl').textContent = pc + ' · ' + price;
      })
      .catch(function (e) { msg.textContent = 'Could not fetch rates. Please try again.'; console.error('[atelier-cart] rates', e); })
      .finally(function () { if (ship) ship.classList.remove('loading'); inflight--; refreshBar(); });
  }

  /* ---------- delegated events ---------- */
  function onClick(e) {
    if (e.target.closest('#AtelierCartClose') || e.target.closest('.ct-cont')) { close(); return; }

    /* "View full cart" — a <button> (not an <a href="/cart">) so slide-cart apps
       (FKcart) can't hijack the click; we navigate ourselves. */
    var viewCart = e.target.closest('[data-ct-viewcart]');
    if (viewCart) { window.location.href = viewCart.getAttribute('data-href') || '/cart'; return; }

    var inc = e.target.closest('[data-ct-plus]'), dec = e.target.closest('[data-ct-minus]'), rm = e.target.closest('[data-ct-remove]');
    if (inc || dec || rm) {
      var li = e.target.closest('.ct-item'); if (!li) return;
      var key = li.getAttribute('data-key');
      var q = parseInt(li.getAttribute('data-qty'), 10) || 1;
      var nq = inc ? q + 1 : (rm ? 0 : q - 1);
      if (nq <= 0) {
        li.classList.add('removing');
        setTimeout(function () { li.remove(); recompute(); }, 180);
        queue(key, 0);
      } else {
        li.setAttribute('data-qty', nq);
        var nEl = li.querySelector('.ct-qty .n'); if (nEl) nEl.textContent = nq;
        updateLine(li);
        recompute();
        queue(key, nq);
      }
      return;
    }

    var moreBtn = e.target.closest('.ct-more-btn');
    if (moreBtn) {
      var props = moreBtn.closest('.ct-props');
      var isOpen = props.classList.toggle('open');
      moreBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      moreBtn.textContent = isOpen ? 'Show less' : moreBtn.getAttribute('data-more');
      return;
    }

    var noteBtn = e.target.closest('.ct-note-btn');
    if (noteBtn) {
      var note = document.getElementById('AtelierCartNote'); note.classList.add('open');
      var ta = note.querySelector('textarea'); if (ta) ta.focus();
      return;
    }

    var tool = e.target.closest('.ct-tool');
    if (tool) {
      var t = tool.dataset.tool, isOn = tool.classList.contains('on');
      drawer.querySelectorAll('.ct-tool').forEach(function (x) { x.classList.toggle('on', x === tool && !isOn); });
      drawer.querySelectorAll('.ct-tool-panel').forEach(function (p) { p.classList.toggle('on', p.dataset.panel === t && !isOn); });
      document.getElementById('AtelierToolWrap').classList.toggle('open', !isOn);
      if (!isOn) { var inp = drawer.querySelector('.ct-tool-panel[data-panel="' + t + '"] input'); if (inp) setTimeout(function () { inp.focus(); }, 260); }
      /* Ship tool opened with a remembered locality (saved here or on a PDP)
         and no rate yet -> quote it straight away. */
      if (!isOn && t === 'ship') {
        var shipEl = document.getElementById('AtelierShip');
        var shipQ = document.getElementById('AtelierShipQ');
        var savedLoc = loadLoc();
        if (savedLoc && shipEl && !shipEl.classList.contains('done') && !shipEl.classList.contains('loading') && shipQ && !shipQ.value) {
          pickLocality(savedLoc.s, savedLoc.pc, savedLoc.st);
        }
      }
      return;
    }

    var shipOpt = e.target.closest('.ct-ship-opt');
    if (shipOpt) { pickLocality(shipOpt.getAttribute('data-s'), shipOpt.getAttribute('data-pc'), shipOpt.getAttribute('data-st')); return; }

    var shipRes = e.target.closest('.ct-ship-res');
    if (shipRes) { document.getElementById('AtelierShip').classList.remove('done'); var q = document.getElementById('AtelierShipQ'); if (q) { q.value = ''; q.focus(); } return; }

    var discBtn = e.target.closest('#AtelierDiscBtn');
    if (discBtn) { applyDiscount(); return; }

    /* shared by the summary-row pill's x and the panel's Remove button;
       refocus the input only when removing from inside the panel */
    var discRm = e.target.closest('[data-ct-disc-rm]');
    if (discRm) { removeDiscount(!!discRm.closest('.ct-tool-panel')); return; }
  }
  function onSubmit() { /* no <form> in the drawer — shipping is selection-driven */ }
  var debouncedNote = debounce(function (v) { saveNote(v); }, 450);
  var debouncedSearch = debounce(function (v) { loadLocs().then(function () { renderShipList(searchLocs(v)); }); }, 120);
  function onInput(e) {
    if (e.target.id === 'AtelierShipQ') { debouncedSearch(e.target.value); return; }
    if (e.target.closest('#AtelierCartNote') && e.target.tagName === 'TEXTAREA') { debouncedNote(e.target.value); }
  }

  /* ---------- global add-to-cart interception ---------- */
  var adding = false;
  document.addEventListener('submit', function (e) {
    if (!window.atelierCartOn) return;
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    if (adding) return;
    adding = true; inflight++; refreshBar();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');
    var fd = new FormData(form);
    fd.append('sections', 'atelier-cart');
    fd.append('sections_url', location.pathname);
    cartFetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) {
        if (btn) btn.classList.remove('loading');
        if (!r.ok) { console.error('[atelier-cart] add http', r.status); return null; }
        return r.json();
      })
      .then(function (data) {
        if (!data) return;
        if (data.status) { console.error('[atelier-cart] add rejected', data); return; }
        if (data.sections && data.sections['atelier-cart']) applySection(data.sections['atelier-cart']);
        show();
        syncBadgeFromDrawer();
      })
      .catch(function (err) { if (btn) btn.classList.remove('loading'); console.error('[atelier-cart] add', err); })
      .finally(function () { adding = false; inflight--; refreshBar(); });
  });

  /* open the drawer. If passed pre-rendered section HTML (e.g. from a /cart/add.js `sections`
     response), apply it directly instead of doing a second fetch - saves a round-trip.
     Called with no argument everywhere else, so behaviour is unchanged for those callers. */
  window.openAtelierCart = function (html) {
    if (!bind()) return;
    show();
    if (typeof html === 'string' && html) { applySection(html); cleanupOrphans(); }
    else { refresh().then(function () { cleanupOrphans(); }); }
  };

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
